import { ShaderChunk } from "three";
import _ from "lodash";
import { ColorLerpChunk } from "./ColorLerpChunk";
import { SkinChunk } from "./SkinChunk";
import { DecalChunk } from "./DecalChunk";
import TochiShaderChunk from "./TochiShaderChunk";

export const loadShaderChunks = () => {
  loadChunk(ColorLerpChunk);
  loadChunk(SkinChunk);
  loadChunk(DecalChunk);
};

const loadChunk = (chunk: TochiShaderChunk) => {
  loadShaderChunkHelper(
    `tochi_${chunk.name}_vert_premain`,
    chunk.vertexShader.premain
  );
  loadShaderChunkHelper(
    `tochi_${chunk.name}_vert_main`,
    chunk.vertexShader.main
  );
  loadShaderChunkHelper(
    `tochi_${chunk.name}_frag_premain`,
    chunk.fragmentShader.premain
  );
  loadShaderChunkHelper(
    `tochi_${chunk.name}_frag_main`,
    chunk.fragmentShader.main
  );
};

const loadShaderChunkHelper = (id: string, code?: string) => {
  if (!_.isUndefined(code)) {
    (ShaderChunk as any)[id] = code;
  }
};

export * from "./ColorLerpChunk";
export * from "./DecalChunk";
export * from "./SkinChunk";
